module.exports = __webpack_public_path__ + "media/images/icons/home-f293e06f1a50e82535450a25553faefb.svg";